module.exports = __webpack_public_path__ + "img/loading.499834b2.gif";